import { render, staticRenderFns } from "./Negociadores.vue?vue&type=template&id=38b519ca&scoped=true"
import script from "./Negociadores.vue?vue&type=script&lang=js"
export * from "./Negociadores.vue?vue&type=script&lang=js"
import style0 from "./Negociadores.vue?vue&type=style&index=0&id=38b519ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b519ca",
  null
  
)

export default component.exports